import { DynamicTabsService } from '../dynamic-tabs.service';
import { INavbarData, INavbarDataItem } from './helper';


export const navbarData: INavbarData[] = [
  {
    routerLink: 'main',
    icon: 'fa fa-home',
    label: 'Main',
    items: [
      {
        id:-5,
        routerLink: 'main/home',

        label: 'Home',
        type:'policy'

      },
    ],
  },
  {
    routerLink: 'associations',
    icon: 'fa fa-file',
    label: 'Associations',

    items: [
      {
        id:-6,
        routerLink: 'associations/associations',
        // tabname : 'Associations',
        label: 'Associations'
      },
      {
        id:-7,
        routerLink: 'AssnAddNew',
        // tabname : 'AssociationsAddNew',
        label: 'Add New'

      }
    ]
  },
  {
    routerLink: 'masterpolicies',
    icon: 'fa fa-address-book-o',
    label: 'Master Policies',


    items: [
      {
        id:-8,
        routerLink: 'masterpolicies/masterpolicies',

        label: 'Master Policies',
      },
      {
        id:-9,
        routerLink: 'masterpolicies/premiumtransactions',

        label: 'Premium Transactions'
      },
      {
        id:-10,
        routerLink: 'policyAddNew',

        label: 'Add New'
      }
    ]
  },
  {
    routerLink: 'guides',
    icon: 'fa fa-adjust',
    label: 'Guides & Outfitters Apps',

    items: [
      {
        id:-11,
        routerLink: 'guides/abandoned',

        label: 'Abandoned Apps',
      }

    ]
  },
];
